import React from 'react';
import './Gallery.css';

const galleryRow1 = [
  { id: 1, image: '/images/gallery-1.webp', alt: 'Коробка из нержавеющей стали AISI 304' },
  { id: 2, image: '/images/gallery-2.webp', alt: 'Шкаф из нержавеющей стали AISI 304' },
  { id: 3, image: '/images/gallery-3.webp', alt: 'Корпус из нержавеющей стали AISI 304' },
  { id: 4, image: '/images/gallery-4.webp', alt: 'Пульт управления из нержавеющей стали AISI 304' },
];

const galleryRow2 = [
  { id: 5, image: '/images/gallery-5.webp', alt: 'Электротехнический шкаф из нержавеющей стали AISI 304' },
  { id: 6, image: '/images/gallery-6.webp', alt: 'Шкаф из нержавеющей стали AISI 316 нестандартный' },
  { id: 7, image: '/images/gallery-7.webp', alt: 'Гигиенический корпус с уклоном 30°' },
];

const Gallery = () => {
  return (
    <section id="gallery" className="gallery-section">
      <div className="gallery-title-section">
        <div className="container-custom">
          <h2 className="gallery-main-title">галерея</h2>
        </div>
      </div>
      
      <div className="gallery-row">
        {galleryRow1.map((item) => (
          <div key={item.id} className="gallery-item">
            <img src={item.image} alt={item.alt} className="gallery-image" />
          </div>
        ))}
      </div>
      <div className="gallery-row gallery-row-3">
        {galleryRow2.map((item) => (
          <div key={item.id} className="gallery-item">
            <img src={item.image} alt={item.alt} className="gallery-image" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
